module.exports = __webpack_public_path__ + "static/media/biontech.527ce825.jpeg";